import { type ISortBy } from 'features/interfaces';

export const defaultSort: ISortBy[] = [
  { id: 'source.sortOrder' },
  { id: 'otherSource' },
  { id: 'page' },
];
